/** Zed AbilitySpec seed kit (wiki-aligned numeric batch 3). */
export const ZED_ABILITY_DEFS = [
  {
    id: 'zed_q',
    champKey: 'zed',
    slot: 'Q',
    name: 'Razor Shuriken',
    targeting: 'skillshot_line',
    range: 925,
    castTime: 0.25,
    travelSpeed: 1700,
    width: 100,
    radius: 50,
    cooldown: 6,
    manaCost: 75,
    costType: 'energy',
    vfxId: 'zed_q',
    status: 'wired'
  },
  {
    id: 'zed_w',
    champKey: 'zed',
    slot: 'W',
    name: 'Living Shadow',
    targeting: 'ground_aoe',
    range: 650,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 20,
    duration: 5.25,
    manaCost: 40,
    costType: 'energy',
    vfxId: 'zed_w',
    status: 'wired'
  },
  {
    id: 'zed_e',
    champKey: 'zed',
    slot: 'E',
    name: 'Shadow Slash',
    targeting: 'aoe_self',
    range: 315,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: 315,
    cooldown: 5,
    manaCost: 40,
    costType: 'energy',
    vfxId: 'zed_e',
    status: 'wired'
  },
  {
    id: 'zed_r',
    champKey: 'zed',
    slot: 'R',
    name: 'Death Mark',
    targeting: 'targeted',
    range: 625,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 120,
    manaCost: 0,
    costType: 'energy',
    vfxId: 'zed_r',
    status: 'wired'
  }
];
